import WPNotice from './wp-notice'

export default WPNotice



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-wp-notice/src/components/wp-notice/index.js
// module id = null
// module chunks = 